/* eslint-disable css-modules/no-unused-class  */
import { FC, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Gallery from '@components/assessments/gallery';
import ResultCard, { ResultsCardProps } from '../resultCard/resultCard';
import styles from './tournamentsResults.module.scss';

const TournamentsResults: FC<{ tournamentsResults: ResultsCardProps[] }> = ({
    tournamentsResults
}: {
    tournamentsResults: ResultsCardProps[];
}) => {
    const tournamentResultRef = useRef<HTMLDivElement>(null);
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const result = searchParams.get('result');
        if (Boolean(result) && tournamentResultRef.current) {
            tournamentResultRef.current.scrollIntoView();
        }
    }, [location.search]);

    return (
        <div className={styles['tournaments-results-wrapper']} ref={tournamentResultRef}>
            <div className={styles['tournament-section-gallery']}>
                {tournamentsResults.length > 1 ? (
                    <Gallery elementWidth="30rem" numberOfElements={tournamentsResults.length}>
                        {tournamentsResults.map((tournament, i) => (
                            <ResultCard {...tournament} key={i} />
                        ))}
                    </Gallery>
                ) : (
                    <ResultCard {...tournamentsResults[0]} />
                )}
            </div>
        </div>
    );
};

export default TournamentsResults;
